<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/O5f7vf/tc-custom/9781488061226.jpg?1705015262313" alt="This image is the cover for the book Amish Sanctuary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amish Sanctuary
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman on the run. A baby in danger.<br/><br/>Can her Amish ex-fiancé save them?<br/><br/></b>To keep her patient’s baby safe from a killer, counselor Naomi Kemp will do things she never thought possible, like return to her Amish hometown…and her ex-fiancé. Widower Sawyer Zook can offer Naomi and the baby protection and a place to hide. But Sawyer can’t shield Naomi from what threatens her most: the traumatic past that drove her away years ago…
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katy Lee
      </h2>
      
      <p class="authorDescription body article">Best-selling and award-winning author Katy Lee writes novels filled with romance, suspense and inspiration. She lives in the rugged beauty of the Utah mountains where she is also a special education teacher at a school for international students. Katy loves to knit warm wooly things while plotting her next suspense story. Keep up with Katy at KatyLeeBooks.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01ee8bc6